import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";

export default function Loading() {
  const isLoading = useSelector((state) => state.IsLoading.isLoading);
  return (
    <Modal
      open={isLoading}
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      {/* <Box
                sx={{
                    width: 200,
                    height: 60,
                    backgroundColor: 'white',
                    '&:hover': {
                        backgroundColor: 'white',
                    },
                }}
            > */}
      <CircularProgress
        style={{
          color: "#1976d2",
          verticalAlign: "middle",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
      {/* <p style={{ display: "inline-block", verticalAlign: "middle", marginLeft: "20px", fontSize: "20px" }}>Loading</p> */}
      {/* </Box> */}
    </Modal>
  );
}
